import { Affix } from "antd";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import DropDown from "../../core/DropDown";
import SubmitButton from "../../core/SubmitButton";
import SubmitControl from "../../core/SubmitControl";
import ClassificationSelection from "../page/ClassificationSelection";
import ComponentHeader from "../../core/ComponentHeader";

const AdvancedSearch = props => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="distance-from-tab" />
      <div>
        <ComponentHeader title={labels.advancedSearch} showBackButton />
      </div>
      <div className="column-header-filtered">
        <Form.Label className="advanced_search_description">
          <i>{labels.advancedSearchDescription}</i>
        </Form.Label>
      </div>
      <Form>
        <Form.Group controlId="correctWords" className="distance-from-tab">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.correctWords}</Form.Label>
            </Col>
            <Col>
              <SubmitControl
                autoFocus
                type="text"
                placeholder={labels.advancedSearchPlaceholder}
                value={props.advancedSearchParams.correctWords.filterVal}
                onChange={props.handleDialogChange}
              ></SubmitControl>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group controlId="phrases" className="distance-from-tab">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.phrases}</Form.Label>
            </Col>
            <Col>
              <SubmitControl
                type="text"
                placeholder={labels.advancedSearchPlaceholder}
                value={props.advancedSearchParams.phrases.filterVal}
                onChange={props.handleDialogChange}
              ></SubmitControl>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group controlId="anyWords" className="distance-from-tab">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.anyWords}</Form.Label>
            </Col>
            <Col>
              <SubmitControl
                type="text"
                placeholder={labels.advancedSearchPlaceholder}
                value={props.advancedSearchParams.anyWords.filterVal}
                onChange={props.handleDialogChange}
              ></SubmitControl>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group controlId="nonWords" className="distance-from-tab">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.nonWords}</Form.Label>
            </Col>
            <Col>
              <SubmitControl
                type="text"
                placeholder={labels.advancedSearchPlaceholder}
                value={props.advancedSearchParams.nonWords.filterVal}
                onChange={props.handleDialogChange}
                maxLength=""
              ></SubmitControl>
            </Col>
          </Row>
        </Form.Group>
        <Form.Group controlId="extensions">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.extensions}</Form.Label>
            </Col>
            <Col>
              <DropDown
                value={props.advancedSearchParams.extensions.filterVal}
                options={props.extensions.map(x => ({
                  value: x,
                  label: x.id
                }))}
                onChange={props.handleDialogChange}
                targetId={"extensions"}
                placeholder={labels.extensions}
                isClearable={true}
                isMulti={true}
              />
            </Col>
          </Row>
        </Form.Group>
        <ClassificationSelection
          setClassificationsOnEntity={props.onSelectClassification}
          messageHandler={props.messageHandler}
          classifications={props.advancedSearchParams.classifications.filterVal}
          classificationsFilter={props.classificationsFilter}
        />
        <Affix offsetBottom={true}>
          <div className="bottom_bar">
            <SubmitButton
              type="search"
              text={labels.search}
              onClick={props.handleAdvancedSearch}
              showLoader
            />
            <Button
              className="buttonStyle"
              variant="danger"
              title={labels.resetAdvancedSearchParams}
              onClick={props.resetAdvancedSearchParams}
            >
              {labels.resetAdvancedSearchParams}
            </Button>
          </div>
        </Affix>
      </Form>
    </div>
  );
};

export default AdvancedSearch;
